import React from 'react';
import { GUARANTEE_NOTE } from '../data/checkout';

/** Discreet guarantee line, shown once under the final purchase button. */
export function GuaranteeNote({
  tone = 'light',
  className = ''
}: {
  tone?: 'light' | 'dark';
  className?: string;
}) {
  return <p className={`text-[0.8rem] leading-relaxed ${tone === 'dark' ? 'text-white/65' : 'text-graphite-soft/80'} ${className}`} data-id="element-69" data-mp="2pgc9cnln8p5e">
      {GUARANTEE_NOTE}
    </p>;
}